export default __webpack_public_path__ + "static/media/Marique's Bitchmage Cache.e09a67a9.jpg";